import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Strangest line of python you have ever seen",
  "description": "",
  "published": "2011-11-18T00:00:00.000Z",
  "redirect_from": ["/blog/strangest-line-of-python-you-have-ever-seen/swizec/3012"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/300px-NFAexample.svg_1.png",
        "alt": "An example of a NFA state diagram.",
        "title": "An example of a NFA state diagram."
      }}></img></p>
    <p>{`The other day `}<a parentName="p" {...{
        "href": "http://twitter.com/HairyFotr"
      }}>{`@HairyFotr`}</a>{` and `}<a parentName="p" {...{
        "href": "http://twitter.com/zidarsk8"
      }}>{`@zidarsk8`}</a>{` were doing some `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Code_golf"
      }}>{`codegolfing`}</a>{` with implementations of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Nondeterministic_finite-state_machine",
        "title": "Nondeterministic finite-state machine"
      }}>{`nondeterministic finite state machine`}</a>{`and asked me to blog their results.`}</p>
    <p>{`For those of us who often forget what all of this computer science mumbo jumbo means, here's a quick explanation from wikipedia:`}</p>
    <blockquote>
      <p parentName="blockquote">{`In the `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Theory_of_computation",
          "title": "Theory of computation"
        }}>{`theory of computation`}</a>{`, a `}<strong parentName="p">{`nondeterministic finite state machine`}</strong>{` or `}<strong parentName="p">{`nondeterministic finite automaton (NFA)`}</strong>{` is a `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Finite_state_machine",
          "title": "Finite state machine"
        }}>{`finite state machine`}</a>{` where for each pair of state and input symbol there may be several possible next states.`}</p>
    </blockquote>
    <p>{`Essentially they were looking for the shortest implementation of an algorithm that can take a bunch of states, go through all of them on each step and then backtrack to find the solution.`}</p>
    <p>{`@zidarsk8 doesn't really know python all that well so his way to optimize things was basically "SHORTEN ALL THE CODES!" and as a result he came up with this line `}<em parentName="p">{`nobody`}</em>{` understands.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`state = [st for s in state for st in states[(s,letter)]]
`}</code></pre>
    <p>{`At first it looks just like a double loop. But then you notice the right-most for is taking the list to iterate over from its own body, which is the iterator of the left-most for loop ...`}</p>
    <p>{`What?`}</p>
    <p>{`Seriously, if you can explain how this works you win a lot of internets, eternal fame and I might just send you a box of cookies.`}</p>
    <p>{`Here's the whole implementation in case you were wondering`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from optparse import OptionParser
from collections import defaultdict

def run(beseda):
       a, states = open("machine.txt") ,defaultdict(list)
       state, final= a.readline().split()[1:],a.readline().split()[1:]
       [states[(i.split()[0], i.split()[1])].append(i.split()[3]) for i in a]
       for letter in word:
               state = [st for s in state for st in states[(s,letter)]]
       return any(i in state for i in final)

print [(b,"YES") if run(b) else (b,"NO") for b in OptionParser().parse_args()[1]]
`}</code></pre>
    <p>{`According to our best debugging efforts it works as advertised ... even though we can't actually understand `}<em parentName="p">{`why`}</em>{` or how it's even possible that python knows what to do.`}</p>
    <p>{`For curiosity's sake, here's @HairyFotr's `}<a parentName="p" {...{
        "href": "http://www.scala-lang.org/",
        "title": "Scala (programming language)"
      }}>{`Scala`}</a>{` implementation`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-scala"
      }}>{`object NKA extends App {
    import scala.collection.mutable._
    val gates = new HashMap[(String,Char), ListBuffer[String]]
    val lines = io.Source.fromFile("avtomat.txt").getLines.toSeq
    val (init,finals) = (lines(0).split(" ")(1),lines(1).split(" ").tail)
    lines.tail.tail.map(_.split(" ")).foreach
        {s => gates.getOrElseUpdate((s(0),s(1)(0)), ListBuffer()) += s(3)}

    def crawl(state:String, input:String):Boolean =
        (input!="" && (false /: gates.getOrElse((state,input(0)), return false))
            {_ || crawl(_, input.tail)}) || (input=="" & finals.contains(state))

    args.foreach(in => println(in + (if(crawl(init,in)) ": YES" else ": NO")))
`}</code></pre>
    <p>{`If you ask me, this looks like a bunch of gibberish and even HairyFotr says it isn't the prettiest Scala code out there. But hey, this is codegolf, all that matters is minimizing those keystrokes!`}</p>
    <p>{`To conclude, two challenges:`}</p>
    <ol>
      <li parentName="ol">{`Explain how that line of python works`}</li>
      <li parentName="ol">{`Come up with a shorter solution ... I'm guessing golfscript is a good choice`}</li>
    </ol>
    <p>{`PS: I was serious about those cookies`}</p>
    <p>{`PPS: an example of what the automata decription looks like `}<a parentName="p" {...{
        "href": "http://pastebin.com/QLW1BfFj"
      }}>{`http://pastebin.com/QLW1BfFj`}</a></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nikhatshahin.wordpress.com/2011/11/13/when-should-we-use-a-sequential-workflow-and-when-should-we-use-state-machines/"
        }}>{`when should we use a sequential workflow and when should we use state machines?`}</a>{` (nikhatshahin.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://markusjais.com/why-scala-seems-difficult-but-reallyisnt/"
        }}>{`Why Scala seems difficult but really isn't`}</a>{` (markusjais.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://xlinux.nist.gov/dads//"
        }}>{`Dictionary of Algorithms and Datastructures`}</a>{` (xlinux.nist.gov)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eli.thegreenplace.net/2011/10/28/an-observation-on-writing-line-processing-loop-code/"
        }}>{`An observation on writing line-processing loop code`}</a>{` (eli.thegreenplace.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://minimalj.wordpress.com/2011/09/05/non-deterministic-infinite-state-automaton/"
        }}>{`Non-Deterministic Infinite-State Automaton`}</a>{` (minimalj.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7d434145-b98a-4e4d-894d-432c5ab1fdcc",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      